import { connect } from "react-redux";
import ViewCad from "../../../view";
import { mapDispatchToTabelaPrecoProps, mapStateToTabelaPrecoProps, tabelaPrecoController, TabelaPrecoViewProps } from "./tabpreco.controll"
import { TabelaPrecoConfig } from "./tabpreco.model"
import { useEffect } from "react";
import { Select as ViewList } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import Modal from "../../../components/modal";
import store from "../../../store";

interface TabelaPrecoCadProps extends TabelaPrecoViewProps {
    handleCloseView: () => any
}

function TabelaPrecoCad(props: TabelaPrecoCadProps) {
    const { tabelaPrecoActions, tabelaPrecoState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = tabelaPrecoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = tabelaPrecoActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: TabelaPrecoConfig) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: TabelaPrecoConfig) => {
        const errors: any = {}
        if (!values.descricao)
            errors.nome = "Informe a descrição da tabela de preço"
        return errors
    }

    const handleUpdate = (value: TabelaPrecoConfig) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
        handleCloseView();
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro da tabela de preços",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar nova tabela de preço",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "descricao", label: "Descrição", type: "text", key: "nome", colunsXS: 8, colunsSM: 8, colunsMD: 8, require: true },
            { fieldName: "ativo", label: "Ativo?", type: "checkbox", key: "ativo", colunsXS: 4, colunsSM: 4, colunsMD: 4, },
        ],
    })

    return viewCad
}


const columns: GridColDef[] = [
    { field: 'descricao', headerName: 'Descricão', flex: 8 },
    { field: 'ativo', headerName: 'Ativo?', flex: 4, renderCell: (prm) => prm.value ? "Sim" : "Não" },
]

function TabelaPrecoLisView(props: TabelaPrecoViewProps) {

    const { tabelaPrecoActions, tabelaPrecoState } = props
    const { error, loading, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList, showSelectModal } = tabelaPrecoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal } = tabelaPrecoActions

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: TabelaPrecoConfig) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        setClearValue();
        setShowCadModal(false)
    }

    const List = (propsList: { handleOnClick: (row: TabelaPrecoConfig) => any }) => {
        const { handleOnClick } = propsList
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Tabelas de Preços"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleOnClick}
                actionsOnkeyEnter={handleOnClick}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columns}
                rows={rows}
                loading={loading}
                setRow={handleOnClick}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => read()
                }}
                ListItemTextPrimary={(row: TabelaPrecoConfig) => <Typography component={"span"}>{row.descricao}</Typography>}
            />
        )
    }

    const Cadastro = () => {
        return TabelaPrecoCad({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: props.tabelaPrecoState.showCadModal,
            heigth: "auto",
            width: "sm"
        })
    }


    const View = (
        <Box>
            <List handleOnClick={handleAlterar} />
            <Cadastro />
        </Box>
    )
    return {
        View,
        List,
    }
}

const TabelaPrecoCadModal = connect(mapStateToTabelaPrecoProps, mapDispatchToTabelaPrecoProps)(
    (props: TabelaPrecoCadProps) => {
        const cadastro = TabelaPrecoCad(props).renderModal({
            handleClose: props.handleCloseView,
            show: props.tabelaPrecoState.showCadModal,
            heigth: "auto",
            width: "sm"
        })
    }
)

const TabelaPrecoList = connect(mapStateToTabelaPrecoProps, mapDispatchToTabelaPrecoProps)(
    (props: TabelaPrecoViewProps) => {
        useEffect(()=>{
            props.tabelaPrecoActions.read();
        },[])
        return TabelaPrecoLisView(props).View
    }
)

interface TabelaPrecoSelectProps extends TabelaPrecoViewProps {
    handleTabelaPrecoSelect: (row: TabelaPrecoConfig) => any
}

const TabelaPrecoSelect = connect(mapStateToTabelaPrecoProps, mapDispatchToTabelaPrecoProps)(
    (props: TabelaPrecoSelectProps) => {
        const { showSelectModal, rows } = props.tabelaPrecoState
        useEffect(() => {
            if (showSelectModal && rows.length === 0)
                props.tabelaPrecoActions.read()
        }, [])
        return (
            <Modal
                component={TabelaPrecoLisView(props).List({ handleOnClick: props.handleTabelaPrecoSelect })}
                handleClose={() => props.tabelaPrecoActions.setShowSelectModal(false)}
                open={props.tabelaPrecoState.showSelectModal}
                width="sm"
                heigth="auto"
                handleOnKeyDown={(ev) => {
                }}
            />
        )
    }
)

const handleShowTabelaPrecoSelect = (set: boolean) => {
    store.dispatch(tabelaPrecoController.reducer.actions.setShowSelectModal(set))
}

export {
    TabelaPrecoCadModal,
    TabelaPrecoList,
    TabelaPrecoSelect,
    handleShowTabelaPrecoSelect

}